/** FLD-OFF — the device store. IndexedDB, four object stores, no library. */
const DB = "fieldops-offline";
const STORES = ["api-cache", "outbox", "blobs", "meta"];
let dbp = null;

function open() {
  if (dbp) return dbp;
  dbp = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") { reject(new Error("no idb")); return; }
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => STORES.forEach((s) => { if (!req.result.objectStoreNames.contains(s)) req.result.createObjectStore(s); });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
  return dbp;
}

const tx = async (store, mode, fn) => {
  const d = await open();
  return new Promise((resolve, reject) => {
    const t = d.transaction(store, mode);
    const r = fn(t.objectStore(store));
    t.oncomplete = () => resolve(r && "result" in r ? r.result : undefined);
    t.onerror = () => reject(t.error);
  });
};

export const idb = {
  get: (store, key) => tx(store, "readonly", (s) => s.get(key)).catch(() => undefined),
  set: (store, key, val) => tx(store, "readwrite", (s) => s.put(val, key)).catch(() => undefined),
  del: (store, key) => tx(store, "readwrite", (s) => s.delete(key)).catch(() => undefined),
  keys: (store) => tx(store, "readonly", (s) => s.getAllKeys()).catch(() => []),
  all: (store) => tx(store, "readonly", (s) => s.getAll()).catch(() => []),
  clear: (store) => tx(store, "readwrite", (s) => s.clear()).catch(() => undefined),
};

export const uuid = () => (crypto.randomUUID ? crypto.randomUUID()
  : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => { const r = (Math.random() * 16) | 0; return (c === "x" ? r : (r & 0x3) | 0x8).toString(16); }));

export async function deviceId() {
  let id = await idb.get("meta", "device_id");
  if (!id) { id = uuid(); await idb.set("meta", "device_id", id); }
  return id;
}

export async function storageEstimate() {
  try { const e = await navigator.storage.estimate(); return e.usage || 0; } catch { return 0; }
}
